export const dashboardRoutes = {
  path: 'dashboard',
  name: 'admin',
  component: () => import('@/views/Dashboard')
}
